import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { Box, Typography } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import React from "react";

export const WorkerPreviewBox = ({
  name,
  initials,
  info,
  x,
  y,
}: {
  name: string;
  initials: string;
  info: string;
  x: number;
  y: number;
}) => (
  <Box
    sx={{
      position: "fixed",
      pointerEvents: "none",
      top: y + 8,
      left: x + 8,
      zIndex: 9999,
    }}
  >
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        width: "318px",
        height: "56px",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          backgroundColor: "#eee",
          padding: "8px 12px 8px 4px",
          borderRadius: "4px",
          mb: 1,
          cursor: "grab",
          width: "318px",
          height: "56px",
          gap: "4px",
        }}
      >
        <DragIndicatorIcon
          sx={{ fontSize: 24, color: "rgba(0,0,0,0.54)" }}
        />
        <Avatar sx={{
          backgroundColor: "#e0e0e0",
          border: "1px solid rgba(0,0,0,0.14)",
        }}>
          <Typography sx={{
            fontFamily: "Roboto",
            fontSize: "16px",
            color: "rgba(0,0,0,0.87)",
            width: "fit-content",
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
            maxWidth: "100%",
          }}>
            {initials}
          </Typography>
        </Avatar>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "center",
            maxWidth: "65%",
            paddingLeft: "4px",
          }}
        >
          <Typography
            sx={{
              fontFamily: "Roboto",
              fontSize: "14px",
              color: "rgba(0,0,0,0.87)",
              width: "fit-content",
              textOverflow: "ellipsis",
              overflow: "hidden",
              whiteSpace: "nowrap",
              maxWidth: "100%",
            }}
          >
            {name}
          </Typography>
          <Typography
            sx={{
              fontFamily: "Roboto",
              fontSize: "12px",
              color: "rgba(0,0,0,0.6)",
              width: "fit-content",
              textOverflow: "ellipsis",
              overflow: "hidden",
              whiteSpace: "nowrap",
              maxWidth: "100%",
            }}
          >
            {info}
          </Typography>
        </Box>
      </Box>
    </Box>
  </Box>
);
